
import live_streaming from '../assets/live_streaming.png'
import { AiOutlineHistory, AiOutlineUser, AiOutlineDollarCircle, AiOutlineGift, AiOutlineMail } from "react-icons/ai";
import { BiStore } from "react-icons/bi";
import ReactLogo from '../assets/voucher.svg';
import { TiTicket } from "react-icons/ti";
import { MdListAlt } from "react-icons/md";

export const topRights = [
    {
        id: 'balance',
        title: 'Saldo',
        link: '/balance',
        icon: <AiOutlineDollarCircle />
    }
]
